import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from '@/shared/components/notifications';
import { SearchContextProvider } from '@/shared/contexts/SearchContextProvider';
import '@/config/i18nConfig';
import App from './App';
import './assets/styles/global.css';
import { registerSW } from 'virtual:pwa-register';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

// Register service worker for PWA functionality
const updateSW = registerSW({
  onNeedRefresh() {
    // Show a prompt to user for updating the app
    if (confirm('New content available. Reload to update?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});

// Render app without MSAL (using deeplink authentication only)
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <SnackbarProvider>
      <SearchContextProvider>
        <App />
      </SearchContextProvider>
    </SnackbarProvider>
  </React.StrictMode>
);
